/**
 * API Introduction page — base URL, authentication, resource overview.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { apiIntroductionContent } from "@/constants/docs/api-introduction";

export const Route = createFileRoute("/docs/api-introduction")({
	component: ApiIntroductionPage,
});

function ApiIntroductionPage() {
	return <DocsPage title="Introduction" content={apiIntroductionContent} />;
}
